export const getImageElement = (
  base64string: string,
): Promise<HTMLImageElement> => {
  return new Promise((resolved, rejected) => {
    const i = new Image()
    i.onload = () => resolved(i)
    i.onerror = e => rejected(e)
    i.src = base64string
  })
}
